import { takeLatest } from 'redux-saga/effects'
import { CREATE_TEMPLATE_SAGA } from 'src/store/types/templatePhrases'
import createTemplate from './createTemplate'

export function* createTemplateSaga() {
  yield takeLatest(CREATE_TEMPLATE_SAGA, createTemplate)
}
